@let isArabic = isArabic$ | async;

<div class="modal fade" id="emailModal" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered modal-lg" [ngClass]="{ show: isVisible }">
    <div class="modal-content">
      <div class="modal-header bg-dark text-primary">
        <h1 class="modal-title fs-5" id="exampleModalLabel">
          {{ 'EMAIL_VERIFICATION_TITLE' | translate }}
        </h1>
        <button
          [ngClass]="isArabic ? 'me-auto ms-0' : ''"
          type="button"
          class="btn btn-close bg-primary"
          data-bs-dismiss="modal"
        ></button>
      </div>
      <div class="modal-body bg-primary">
        <p [innerHTML]="'EMAIL_VERIFICATION_INFO' | translate"></p>
        <p>{{ 'EMAIL_CODE_CHECK' | translate }}</p>
        <div class="row g-3 align-items-center">
          <div class="col-auto">
            <label class="col-form-label">{{ 'EMAIL_CODE' | translate }}</label>
          </div>
          <div class="col-auto">
            <input
              type="text"
              [(ngModel)]="code"
              class="form-control"
              aria-describedby="code"
              required
              minlength="6"
            />
          </div>
          <div class="col-auto">
            <button class="btn btn-dark text-primary ms-3" (click)="verifyCode()">
              {{ 'EMAIL_VERIFY' | translate }}
            </button>
          </div>
        </div>

        <button
          [ngClass]="isArabic ? 'float-start' : 'float-end'"
          (click)="sendCode()"
          [disabled]="resendCooldown > 0"
          class="btn btn-send btn-dark text-primary"
        >
          {{
            resendCooldown > 0
              ? ('EMAIL_RESEND_COOLDOWN' | translate) +
                resendCooldown +
                ('EMAIL_SECOND' | translate)
              : ('EMAIL_RESEND_CODE' | translate)
          }}
        </button>

        <p class="message">{{ message }}</p>
      </div>
    </div>
  </div>
</div>
